var _rect, _g, _rect2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_41_488",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_41_488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.23076 0.661766L3.60576 4.2353H6.35576L4.98076 0.661766H6.81409L8.18909 4.2353H10.9391L9.56409 0.661766H11.3974L12.7724 4.2353H15.5224L14.1474 0.661766H15.7692C16.1911 0.661766 16.5434 0.845406 16.826 1.21269C17.1087 1.57996 17.25 2.03772 17.25 2.58596V15.414C17.25 15.9623 17.1087 16.42 16.826 16.7873C16.5434 17.1546 16.1911 17.3382 15.7692 17.3382H2.23076C1.80886 17.3382 1.4566 17.1546 1.17396 16.7873C0.891319 16.42 0.75 15.9623 0.75 15.414V2.58596C0.75 2.03772 0.891319 1.57996 1.17396 1.21269C1.4566 0.845406 1.80886 0.661766 2.23076 0.661766ZM1.66667 5.42647V15.414C1.66667 15.6278 1.71955 15.8035 1.82532 15.9409C1.93109 16.0783 2.06623 16.1471 2.23076 16.1471H15.7692C15.9338 16.1471 16.0689 16.0783 16.1747 15.9409C16.2804 15.8035 16.3333 15.6278 16.3333 15.414V5.42647H1.66667Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_41_488",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 8,
    height: 8
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 7,
    width: 8,
    height: 8,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_41_488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.78922 14.5277C7.57383 14.6703 7.35512 14.6777 7.13308 14.55C6.91103 14.4223 6.8 14.2292 6.8 13.9708V8.02922C6.8 7.77077 6.91103 7.57769 7.13308 7.45C7.35512 7.32231 7.57383 7.32974 7.78922 7.4723L12.4631 10.4585C12.6621 10.5877 12.7615 10.7682 12.7615 11C12.7615 11.2318 12.6621 11.4123 12.4631 11.5415L7.78922 14.5277Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReel);
export default __webpack_public_path__ + "static/media/reel.3c110fd2aa5ae0a60e346b258bcfc213.svg";
export { ForwardRef as ReactComponent };